// API base URL, supplied by the build-time environment rather than hardcoded here.
// See .env.development / .env.production / .env.staging in the project root.
//
// Vue CLI only exposes variables prefixed with VUE_APP_, and inlines them at build
// time — this is not read at runtime, so a production bundle has to be rebuilt (not
// just restarted) to point at a different API.
export const API_URL = process.env.VUE_APP_API_URL

if (!API_URL) {
  // Without this the axios baseURL is undefined and every request quietly falls back
  // to the app's own origin, which looks like a CORS/404 problem rather than config.
  // eslint-disable-next-line no-console
  console.error(
    '[config] VUE_APP_API_URL is not set. Add it to .env.local (or the env file for your build mode) and restart.',
  )
}

export default API_URL
